import React from "react";
import { HeadlineProps } from "components/atoms/Headline/types";
import { HeadlineElement } from "components/atoms/Headline/styles";

const Headline: React.FC<HeadlineProps> = ({ value, size }) => {
  return <HeadlineElement size={size}>{value}</HeadlineElement>;
};

export default Headline;
